module.exports = __webpack_public_path__ + "b5a44720b148fad946f621a0af89c363.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/syncs/stats.png
// module id = 1780
// module chunks = 1